import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getFirestore } from 'firebase/firestore';

/* 
HOW TO GET THESE CREDENTIALS:

1. Go to https://console.firebase.google.com/
2. Create a new project or select existing one
3. Click the web icon (</>)
4. Register your app with a nickname (e.g., "speaky-spokey-web")
5. Copy the firebaseConfig object
6. Set up Realtime Database:
   - Click "Build" → "Realtime Database" in sidebar
   - Click "Create Database"
   - Choose location
   - Start in test mode
7. Copy the databaseURL from the Realtime Database section
8. Replace all values in the firebaseConfig object below

SECURITY NOTE: In a production environment, you should:
- Add security rules to your Realtime Database
- Store these credentials in environment variables
- Add authentication for users
*/

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAQywIr0yXrKLnd0JbL7-njwLK6W03UakQ",
  authDomain: "speakyspokey-9a6b9.firebaseapp.com",
  databaseURL: "https://speakyspokey-9a6b9-default-rtdb.firebaseio.com",
  projectId: "speakyspokey-9a6b9",
  storageBucket: "speakyspokey-9a6b9.firebasestorage.app",
  messagingSenderId: "911970941659",
  appId: "1:911970941659:web:71e1b04572e8772e3e6afe"
};

// Initialize Firebase
console.log('Initializing Firebase...');
const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
export const db = getFirestore(app);
console.log('Firebase initialized successfully'); 